module.exports = __webpack_public_path__ + "img/CB2-L1-A.a1d7932e.gif";